export default {
  common: {
    appName: 'AuthentiGuard',
    loading: 'Loading...',
    confirm: 'Confirm',
    cancel: 'Cancel',
    back: 'Back',
    more: 'More',
    search: 'Search',
    submit: 'Submit',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    required: 'Required',
    optional: 'Optional',
    allRightsReserved: 'All Rights Reserved',
    noMoreData: 'No more data',
    loadMoreText: '上拉加载更多',
    close: 'Close',
    // submit: 'Submit Application',
    submitting: 'Submitting...',
    submitFailed: 'Submission failed, please try again',
    // required: 'This field is required'
    applyNow: 'Apply Now',
    preview: 'Store Preview',
    brandGuide: 'Brand Guide',
    copy: 'Copy',
    systemMessage: 'System Message',
    ok: 'OK'
  },
  nav: {
    home: 'Homepage',
    verification: 'Verification',
    report: 'Report',
    achievements: 'Achievement',
    calendar: 'Calendar',
    brands: 'Brand Hall',
    cooperationCenter: 'Cooperation Center',
    login: 'Login/Register'
  },
  home: {
    heroTitle: 'Guard Every Authenticity, Trust Starts Here',
    heroSubtitle: 'Building a comprehensive anti-counterfeiting protection system for brands and consumers',
    verifyNow: 'Verify Now',
    reportFake: 'Report Fake',
    coreFeatures: 'Our Core Functions',
    oneClickVerification: 'Anti-counterfeiting Verification',
    oneClickVerificationDesc: 'Verify authenticity fast. Protect your rights',
    anonymousReport: 'Anonymous Report',
    anonymousReportDesc: 'Report counterfeits safely. Keep the market fair',
    industryCalendar: 'Industry Calendar',
    industryCalendarDesc: 'Track latest brand updates and events',
    comprehensiveSolution: 'Comprehensive anti-counterfeiting solution to protect your brand and consumer rights',
    // verifyNow: 'Verify Now',
    reportNow: 'Report Now',
    viewCalendar: 'View Calendar',
    trustedBrands: 'Chosen by brands. Reliable and trusted',
    platformAchievements: 'Platform Achievements',
    latestNews: 'Latest Updates',
    verifiedProducts: 'Verified Products',
    handledComplaints: 'Complaints Handled',
    partnerBrands: 'Partner Brands',
    userSatisfaction: 'User Satisfaction',
    viewAllBrands: 'View More Partner Brands',
    viewReport: 'View Detailed Report',
    quickVerification: 'Quick Verification',
    security: 'Security Assurance',
    realTimeUpdates: 'Real-time Updates',
    scanToExperience: 'Scan to experience',
    scanDescription: 'Use your phone to scan the QR code and experience the product features immediately'
  },
  auth: {
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot Password',
    noAccount: 'No account? Register now',
    haveAccount: 'Already have an account? Login',
    loginSuccess: 'Login successful',
    registerSuccess: 'Registration successful',
    logoutSuccess: 'Logout successful'
  },
  verification: {
    title: 'Product Verification',
    // scanCode: 'Scan Code',
    demoCode: 'Use Demo Verification',
    demoTip: 'If you don\'t have a product security code, you can use our demo verification',
    enterCode: 'Enter Security Code',
    verify: 'Verify',
    verificationResult: 'Verification Result',
    genuineProduct: 'Genuine Product',
    fakeProduct: 'Fake Product',
    verificationHistory: 'Verification History',
    batchVerification: 'Batch Verification',
    // title: 'Scan & Verify',
    // enterCode: 'Enter security code',
    // verify: 'Verify',
    // scanCode: 'Scan Code',
    scanGuide: 'Aim at QR code to scan',
    codeRequired: 'Please enter security code',
    codeTooShort: 'Security code is too short',
    codeInvalid: 'Invalid security code',
    verifyFailed: 'Verification failed',
    verifying: 'Verifying...',
    scanSuccess: 'Scan successful',
    cameraNotAvailable: 'Camera not available',

    // 验证结果
    authenticProduct: 'Authentic Product',
    verifiedProduct: 'Verified Product',
    // scanInfo: 'Scan Information',
    // isFirstScan: 'First Scan',
    // scanTimes: 'Scan Times',
    // firstScanTime: 'First Scan Time',
    // currentScanTime: 'Current Scan Time',
    yes: 'Yes',
    no: 'No',
    scanInfo: 'Verification Information',
    isFirstScan: 'First Time Scan',
    scanTimes: 'Scan Times',
    firstScanTime: 'First Verification Time',
    currentScanTime: 'Current Verification Time',

    // 商品信息
    commodityInfo: 'Product Information',
    unknownProduct: 'Unknown Product',
    styleNo: 'Style No.',
    color: 'Color',
    size: 'Size',
    category: 'Category',
    country: 'Country',
    collection: 'Collection',

    // 操作
    verifyAnother: 'Verify Another Product',
    shareResult: 'Share Result',
    shareTitle: 'Share Verification Result',
    sharing: 'Sharing to',
    linkCopied: 'Link copied',

    // 状态
    noResult: 'No verification result found',
    tryAgain: 'Try Again'
  },
  report: {
    title: 'Report Counterfeit',
    brandInfo: 'Brand Information',
    productInfo: 'Product Information',
    purchaseInfo: 'Purchase Information',
    problemInfo: 'Problem Description',
    contactInfo: 'Contact Information',

    brandName: 'Brand Name',
    brandPlaceholder: 'Select brand name',
    brandRequired: 'Please select brand name',
    selectBrand: 'Select Brand',
    customBrand: 'Custom Brand',
    customBrandPlaceholder: 'Please enter brand name',
    customBrandRequired: 'Please enter brand name',

    productName: 'Product Name',
    productNamePlaceholder: 'Enter specific product name',
    productNameRequired: 'Please enter product name',

    purchaseChannel: 'Purchase Channel',
    purchaseChannelPlaceholder: 'e.g., Tmall flagship store, physical store, etc.',
    purchaseChannelRequired: 'Please enter purchase channel',

    purchaseDate: 'Purchase Date',
    purchaseDatePlaceholder: 'Select purchase date',
    purchaseDateRequired: 'Please select purchase date',
    selectDate: 'Select Date',

    problemDescription: 'Problem Description',
    problemDescriptionPlaceholder: 'Please describe the problem in detail, e.g., abnormal product appearance, damaged anti-counterfeit label, different effect from genuine product, etc.',
    problemDescriptionRequired: 'Please describe the problem',

    evidencePhotos: 'Evidence Photos',
    uploadTip: 'Maximum 5 photos, JPG/PNG format, each under 5MB',

    anonymousReport: 'Anonymous Report',
    anonymousTip: 'Your personal information will not be recorded when choosing anonymous reporting. Turn off anonymous option if you need follow-up.',
    contactName: 'Contact Name',
    contactNamePlaceholder: 'Enter your name',
    contactNameRequired: 'Please enter contact name',
    contactPhone: 'Contact Phone',
    contactPhonePlaceholder: 'Enter your phone number',
    contactPhoneRequired: 'Please enter phone number',
    phoneFormatError: 'Please enter valid phone number format',

    submitReport: 'Submit Report',
    submitting: 'Submitting...',
    agreementTip: 'By submitting, you agree to our',
    userAgreement: 'User Agreement',

    successMessage: 'Thank you for your report! We have received your information. You can check the progress through the report records.',
    viewReport: 'View Report Records',
    submitAnother: 'Submit Another',
    brand: 'Brand',
    purchaseLocation: 'Purchase Location',
    description: 'Description',
    uploadEvidence: 'Upload Evidence',
    reportSuccess: 'Report submitted successfully',
    submitSuccess: 'Submission Successful',
    thankYou: 'Thank You for Your Submission',
    caseNumber: 'Case Number',
    trackProgress: 'Track Progress',
    scanToTrack: 'Scan the QR code to track your complaint progress anytime',
    progressQrAlt: 'Complaint Progress QR Code'
  },
  brands: {
    title: 'Brands',
    allBrands: 'Partner Brands',
    featuredBrands: 'Featured Brands',
    productCount: 'Products',
    verificationCount: 'Verifications',
    learnMore: 'Learn More',
    pageSubtitle: 'Explore our premium partner brands, working together to protect product authenticity',
    searchPlaceholder: 'Search brand name or description...',
    noBrandsFound: 'No brands found',
    resetFilters: 'Reset filters',
    featured: 'Featured',
    products: 'Products',
    verifications: 'Verifications',
    viewDetails: 'View Details',
    joinTime: 'Join Time',
    establishTime: 'Establish Time',
    story: 'Brand Story',
    designers: 'Designers',
    verification: 'Brand Verification',
    totalVerifications: 'Total Verifications',
    authenticityRate: 'Authenticity Rate',
    items: 'items',
    verified: 'Verified'
  },
  footer: {
    aboutUs: 'About Us',
    contact: 'Contact',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    newsletter: 'Newsletter',
    newsletterDesc: 'Subscribe to our newsletter for the latest anti-counterfeiting news',
    enterEmail: 'Enter your email',
    subscribe: 'Subscribe'
  },
  errors: {
    networkError: 'Network error, please try again later',
    serverError: 'Server error',
    notFound: 'Requested resource not found',
    unauthorized: 'Unauthorized access',
    invalidCredentials: 'Invalid email or password',
    emailRequired: 'Email is required',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 6 characters',
    passwordNotMatch: 'Passwords do not match'
  },
  calendar: {
    title: 'Industry Calendar',
    subtitle: 'Stay updated with the latest brand news and event schedules',
    monthView: 'Month View',
    listView: 'List View',
    viewDetails: 'View Details',
    eventDescription: 'Event Description',
    participate: 'Participate Now',
    noEvents: 'No Event',

    // Event types
    // conference: 'Conference',
    // exhibition: 'Exhibition',
    // webinar: 'Webinar',
    // promotion: 'Promotion',
    // deadline: 'Deadline',
    showRoom: 'ShowRoom',
    exhibition: 'Exhibition',
    tradeFair: 'Trade Fair', // Trade Fair
    event: 'Event',

    // Months
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',

    // week
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    sunday: 'Sun'
  },
  progress: {
    title: 'Complaint Progress',
    enterComplaintId: 'Please enter complaint ID',
    search: 'Search',
    scanQrCode: 'Scan QR Code',
    invalidId: 'Please enter a valid complaint ID (at least 8 alphanumeric characters)',
    searchFailed: 'Search failed, please try again',

    complaintId: 'Complaint ID',
    submitTime: 'Submission Time',
    productName: 'Product Name',
    complaintType: 'Complaint Type',
    description: 'Description',

    progressTitle: 'Progress',
    statusPending: 'Pending',
    statusInProgress: 'In Progress',
    statusCompleted: 'Completed',

    resultTitle: 'Result',
    result: 'Result',
    solution: 'Solution',
    followUp: 'Follow Up',

    operator: 'Operator',

    needHelp: 'Need help?',
    contactCustomerService: 'Contact our customer service team',
    contactNow: 'Contact Now',
    contactService: 'Contact Service',
    contactConfirm: 'You will contact our customer service team, continue?',
    contactingService: 'Contacting service...',

    howToUse: 'How to Use',
    instruction1: 'Enter your complaint ID in the input box',
    instruction2: 'Or click "Scan QR Code" to scan the QR code on your complaint receipt',
    instruction3: 'Click the search button to view complaint progress',

    noData: 'No relevant complaint record found',
    searchAgain: 'Search Again',

    scanPlaceholder: 'Please align the QR code with the camera',
    mockScan: 'Mock Scan'
  },
  dynamic: {
    detail: 'Dynamic Detail',
    views: 'Dynamic Views'
  },
  applications: {
    department: {
      title: 'Department Store Cooperation',
      subtitle: 'Become our retail partner and share brand ecosystem resources',
      storeName: 'Store Name',
      storeNamePlaceholder: 'Please enter store name',
      groupName: 'Group Name',
      groupNamePlaceholder: 'Please enter group name',
      country: 'Country',
      countryPlaceholder: 'Please enter country',
      city: 'City',
      cityPlaceholder: 'Please enter city',
      address: 'Address',
      addressPlaceholder: 'Please enter detailed address',
      storeLevel: 'Store Level',
      storeLevelOptions: {
        highEnd: 'High-end',
        midHigh: 'Mid-high',
        mass: 'Mass'
      },
      businessArea: 'Business Area(m²)',
      businessAreaPlaceholder: 'Please enter business area',
      annualTraffic: 'Annual Traffic',
      annualTrafficPlaceholder: 'Please enter annual traffic',
      existingBrands: 'Existing Brands',
      existingBrandsPlaceholder: 'Please describe existing main brands in the store...',
      cooperationDescription: 'Cooperation Expectations',
      cooperationDescriptionPlaceholder: 'Please describe your goals through cooperation...'
    },
    brand: {
      title: 'Brand Cooperation Application',
      subtitle: 'Join the brand ecosystem and enjoy full-chain support',
      brandNameCn: 'Brand Name (Chinese)',
      brandNameCnPlaceholder: 'Please enter brand name in Chinese',
      brandNameEn: 'Brand Name (English)',
      brandNameEnPlaceholder: 'Please enter brand name in English',
      brandCountry: 'Brand Origin',
      brandCountryPlaceholder: 'Please enter brand origin',
      establishedYear: 'Established Year',
      establishedYearPlaceholder: 'Please enter established year',
      brandPositioning: 'Brand Positioning',
      brandPositioningOptions: {
        luxury: 'Luxury',
        highEnd: 'High-end',
        designer: 'Designer Brand',
        contemporary: 'Contemporary Fashion',
        mass: 'Mass Brand'
      },
      mainCategories: 'Main Categories',
      mainCategoriesPlaceholder: 'Please enter main categories, e.g. womenswear, accessories',
      existingChannels: 'Existing Channels',
      existingChannelsPlaceholder: 'Please enter existing sales channels, e.g. online, offline stores',
      annualRevenue: 'Annual Revenue (RMB)',
      annualRevenuePlaceholder: 'Please enter annual revenue',
      companyName: 'Company Name',
      companyNamePlaceholder: 'Please enter company name',
      cooperationDescription: 'Cooperation Description',
      cooperationDescriptionPlaceholder: 'Please describe your goals through cooperation...'
    },
    designer: {
      title: 'Designer Application',
      subtitle: 'Showcase creative talent and connect brands with consumers',
      designerName: 'Designer Name',
      designerNamePlaceholder: 'Please enter designer name',
      brandName: 'Brand Name',
      brandNamePlaceholder: 'Please enter brand name',
      designField: 'Design Field',
      designFieldPlaceholder: 'Please enter design field, e.g. fashion design',
      experienceYears: 'Years of Experience',
      experienceYearsPlaceholder: 'Please enter years of experience',
      educationBackground: 'Education Background',
      educationBackgroundPlaceholder: 'Please enter education background',
      workExperience: 'Work Experience',
      workExperiencePlaceholder: 'Please enter work experience',
      representativeWorks: 'Representative Works',
      representativeWorksPlaceholder: 'Please enter representative works',
      awards: 'Awards',
      awardsPlaceholder: 'Please enter awards received',
      personalIntroduction: 'Personal Introduction',
      personalIntroductionPlaceholder: 'Please briefly introduce your design philosophy, experience and achievements...'
    },
    officer: {
      title: 'Officer Recruitment',
      subtitle: 'Become a regional manager and coordinate brand-store relationships',
      applicantName: 'Applicant Name',
      applicantNamePlaceholder: 'Please enter applicant name',
      appliedPosition: 'Applied Position',
      appliedPositionPlaceholder: 'Please enter applied position',
      experienceYears: 'Years of Experience',
      experienceYearsPlaceholder: 'Please enter years of experience',
      educationBackground: 'Education Background',
      educationBackgroundPlaceholder: 'Please enter education background',
      workExperience: 'Work Experience',
      workExperiencePlaceholder: 'Please enter work experience',
      professionalSkills: 'Professional Skills',
      professionalSkillsPlaceholder: 'Please enter professional skills',
      projectExperience: 'Project Experience',
      projectExperiencePlaceholder: 'Please enter project experience',
      selfIntroduction: 'Self Introduction',
      selfIntroductionPlaceholder: 'Please briefly introduce your personal situation and career experience...'
    },
    contactInfo: 'Contact Information',
    contactName: 'Contact Name',
    contactNamePlaceholder: 'Please enter contact name',
    contactPosition: 'Position',
    contactPositionPlaceholder: 'Please enter position',
    contactPhone: 'Contact Phone',
    contactPhonePlaceholder: 'Please enter contact phone',
    contactEmail: 'Email',
    contactEmailPlaceholder: 'Please enter email',
    agreeTerms: 'I have read and agree to the terms and conditions',
    agreeTermsRequired: 'Please read and agree to the terms and conditions',
    // todo
    submitSuccess: 'Submission successful, we will contact you within 3 business days'
  },
  cooperation: {
    center: 'Cooperation Center',
    applicationCenter: 'Cooperation Application Center',
    departmentStores: 'Partner Department Stores',
    noStores: 'Stores Will Be Updating',
    applyFirstStore: 'I Want To Apply',
    department: {
      title: 'Department Store Cooperation',
      subtitle: 'Become Our Retail Partner',
      description: 'Connect with global quality customers, enhance brand power and traffic.'
    },
    brand: {
      title: 'Brand Cooperation',
      subtitle: 'Join Brand Ecosystem',
      description: 'Provide full-chain support from anti-counterfeit to sales for your brand.'
    },
    designer: {
      title: 'Designer Registration',
      subtitle: 'Showcase Your Creativity',
      description: 'Connect brands and consumers, create personal design IP.'
    },
    officer: {
      title: 'Officer Recruitment',
      subtitle: 'Become Regional Cooperation Manager',
      description: 'Coordinate brand and department store relationships, promote regional business development.'
    },
    benefits: {
      department: [
        'Omni-channel brand exposure',
        'Member system integration',
        'Marketing activity support',
        'Data analysis services'
      ],
      brand: [
        'Anti-counterfeit traceability technology',
        'Multi-channel sales network',
        'Brand promotion resources',
        'Event linkage support'
      ],
      designer: [
        'Personal brand showcase',
        'Business cooperation opportunities',
        'Work copyright protection',
        'Industry exchange platform'
      ],
      officer: [
        'Regional business management rights',
        'Generous performance rewards',
        'Professional training system',
        'Career development path'
      ]
    }
  },
  preview: {
    story: 'Brand Story',
    designer: 'Designer',
    products: 'Recent Styles',
    events: 'Brand Events',
    origin: 'Brand Origin',
    originContent: 'Fuguang brand was founded in 2018, originating from the founders thinking about modern womens daily wear. We believe that clothing is not only for covering the body, but also a medium for expressing oneself and conveying attitudes. The brand name "Fuguang" is taken from "fleeting light and shadow", meaning to capture the beautiful moments that pass by in life and solidify them in clothing design.',
    designConcept: 'Design Concept',
    designConceptContent: 'Fuguang is committed to combining Eastern aesthetics with modern design language to create clothing that not only fits the pace of contemporary life but also contains cultural heritage. We pay attention to the selection of fabrics and the details of craftsmanship, pursuing the balance between comfort and aesthetics.',
    designerTitle: 'Chief Designer & Brand Founder',
    designerDesc: 'Graduated from the Academy of Arts & Design, Tsinghua University, previously worked for internationally renowned fashion brands, with 10 years of fashion design experience. Skilled in integrating traditional craftsmanship with modern aesthetics to create contemporary clothing with unique Eastern charm.',
    collection: '2023 Autumn/Winter Collection - "Urban Light and Shadow"',
    collectionDesc: 'This collection draws inspiration from urban architectural lines and light and shadow changes, using simple cuts and soft tones to create daily wear suitable for modern urban women.'
  },
  stores: {
    beijingSKP: {
      name: 'Beijing SKP',
      location: 'No. 87 Jianguo Road, Chaoyang District, Beijing',
      tags: ['Luxury', 'Flagship Store', 'Designer Collection']
    },
    shanghaiIFC: {
      name: 'Shanghai IFC Mall',
      location: 'No. 8 Century Avenue, Pudong New Area, Shanghai',
      tags: ['High-end Shopping', 'International Brands']
    },
    shenzhenMixC: {
      name: 'Shenzhen MixC',
      location: 'No. 1881 Baoan South Road, Luohu District, Shenzhen',
      tags: ['Lifestyle', 'Trendy Brands', 'Dining & Entertainment']
    },
    chengduTaikooli: {
      name: 'Chengdu Taikoo Li',
      location: 'No. 8 Zhongshamao Street, Jinjiang District, Chengdu',
      tags: ['Open Block', 'Cultural Landmark', 'Designer Brands']
    }
  },
  portal: {
    hero: {
      title: 'Build Brand Ecosystem, Create Infinite Possibilities',
      subtitle: 'Group business unified entry platform, integrating anti-counterfeit, brands, channels and event resources to build a complete business ecosystem',
      experienceBtn: 'Experience Now',
      learnMoreBtn: 'Learn More',
      experienceToast: 'Start exploring the ecosystem portal',
      introductionContent: 'The official website domain is currently being upgraded.'
    },
    features: {
      title: 'Core Features',
      experienceLink: 'Experience Now',
      antiCounter: {
        title: 'Anti-counterfeit Platform',
        description: 'Product authentication, counterfeit reporting, traceability query, protecting brand value and consumer rights'
      },
      cooperation: {
        title: 'Cooperation Center',
        description: 'Department store cooperation, brand加盟, designer registration, officer recruitment, one-stop cooperation application'
      },
      brandEcosystem: {
        title: 'Brand Ecosystem',
        description: 'Brand display, store guide, designer stories, explore the complete brand ecosystem'
      },
      calendar: {
        title: 'Event Calendar',
        description: 'Fashion weeks, ordering conferences, industry exhibitions, stay updated with the latest industry trends and event information'
      }
    },
    brands: {
      title: 'Partner Brands Hall',
      fuguang: {
        name: 'Fuguang'
      },
      yayun: {
        name: 'Yayun'
      },
      naturalism: {
        name: 'Naturalism'
      },
      qingyu: {
        name: 'Qingyu'
      },
      shanlan: {
        name: 'Shanlan'
      },
      liushui: {
        name: 'Liushui'
      }
    },
    stats: {
      brands: 'Partner Brands',
      departmentStores: 'Partner Department Stores',
      designers: 'Certified Designers',
      officers: 'Regional Officers'
    },
    footer: {
      about: {
        title: 'About Us',
        introduction: 'Group Introduction',
        history: 'Development History',
        culture: 'Corporate Culture',
        contact: 'Contact Us'
      },
      cooperation: {
        title: 'Business Cooperation',
        departmentStores: 'Department Store Cooperation',
        brands: 'Brand Cooperation',
        designers: 'Designer Registration',
        officers: 'Officer Recruitment'
      },
      help: {
        title: 'Help Center',
        faq: 'FAQ',
        guide: 'User Guide',
        terms: 'Terms of Service',
        privacy: 'Privacy Policy'
      },
      follow: {
        title: 'Follow Us',
        description: 'Get the latest industry trends and event information'
      },
      copyright: '© 2025 Group Business Unified Entry Platform All Rights Reserved 沪ICP备2022009059号-3'
    },
    contact: {
      title: 'Contact Us',
      description: 'Please contact us via the email below, we will reply to you as soon as possible',
      copySuccess: 'Email address copied to clipboard'
    }
  },
  faq: {
    title: 'FAQ',
    searchPlaceholder: 'Search questions...',
    foundQuestions: 'Found {count} related questions',
    noQuestionsFound: 'No related questions found',
    resetSearch: 'Reset Search',
    relatedLinks: 'Related Links',
    needMoreHelp: 'Need more help?',
    contactUs: 'Contact Us',
    contactToast: 'Contacting customer service...',
    categories: {
      all: 'All',
      cooperation: 'Cooperation',
      application: 'Application',
      technical: 'Technical',
      account: 'Account'
    },
    questions: {
      q1: {
        title: 'How to apply for department store cooperation?',
        answer: 'You can submit a department store cooperation application through our cooperation center. The application requires basic store information, business status, existing brands, and cooperation expectations. Our business team will contact you within 15 business days.',
        links: {
          department: 'Department Store Application',
          brand: 'Brand Cooperation Application'
        }
      },
      q2: {
        title: 'What are the requirements for designer registration?',
        answer: 'Designer registration requires providing a portfolio, design philosophy, and relevant qualifications. We welcome creative designers with unique design styles to join our platform. The review period is typically 10-15 business days.',
        links: {
          designer: 'Designer Application',
          officer: 'Officer Recruitment'
        }
      },
      q3: {
        title: 'How long does the application review take?',
        answer: 'Different types of applications have different review times: department store cooperation takes 10-15 business days, brand cooperation takes 10-15 business days, designer registration takes 10-15 business days, and officer recruitment takes 13-17 business days.',
        links: {}
      },
      q4: {
        title: 'How to check application status?',
        answer: 'You can view the status of all applications in the "My Applications" section of your personal center. We will also notify you via email and SMS once approved.',
        links: {}
      },
      q5: {
        title: 'What to do if there are technical issues?',
        answer: 'If you encounter technical issues, please first check your network connection and browser version. If the problem persists, contact our technical support team with detailed descriptions and screenshots, and we will resolve it as soon as possible.',
        links: {}
      },
      q9: {
        title: 'What are the advantages of cooperation?',
        answer: 'Cooperating with us provides benefits including brand exposure, channel resources, technical support, and marketing activities. We are committed to creating maximum value for our partners.',
        links: {}
      },
      q10: {
        title: 'Can I reapply after being rejected?',
        answer: 'Yes. If your application is rejected, we will explain the specific reasons. You can reapply after making improvements based on the feedback, with a recommended interval of at least 30 days.',
        links: {}
      }
    }
  }
}
